import { render, staticRenderFns } from "./MultiplayerMode.vue?vue&type=template&id=edd229be&scoped=true&lang=pug&"
import script from "./MultiplayerMode.vue?vue&type=script&lang=js&"
export * from "./MultiplayerMode.vue?vue&type=script&lang=js&"
import style0 from "./MultiplayerMode.vue?vue&type=style&index=0&id=edd229be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd229be",
  null
  
)

export default component.exports